import { render, staticRenderFns } from "./RiskAdd.vue?vue&type=template&id=422a32e8&"
import script from "./RiskAdd.vue?vue&type=script&lang=js&"
export * from "./RiskAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports